import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../../services/layout.service';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { NavBarItem } from '@shared/models/nav-bar-item.model';
import { ShipmentTemplateService } from '@features/shipment-creation-template/services/shipment-template.service';
import { Observable, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';
import { RolesConstants } from '@shared/constants';
import { UserApi } from '@shared-features/services';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { ShipmentCreationTemplate } from '@features/shipments/models/shipment-template.model';
import { dedupeTemplatesByType } from '@features/shipments/utils/shipment-template.util';
import { map, filter, tap } from 'rxjs/operators';
import { UserRole } from '@shared/enums/global.enum';
import { MatDialog } from '@angular/material/dialog';
import { PreCreateShipmentDialogComponent } from '@layout/components/sidenav/pre-create-shipment-dialog.component';
import { RoutesUtil } from '@shared-features/utils/routes.util';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent extends BaseComponent implements OnInit {
  @Input() items: NavBarItem[];
  @Input() collapsed = false;
  @Input() openMenu = false;
  @Output() changeOpenMenu = new EventEmitter<boolean>();
  @Output() navbarCollapse = new EventEmitter<boolean>(this.collapsed);
  @ViewChild('navList') navList;
  availableTemplates$: Observable<ShipmentCreationTemplate[]>;
  showTemplatesMenu = false;
  public userFirstName = '';
  public userLastName = '';
  public userEmail = '';
  public userLogo: string;
  RoutesUtil = RoutesUtil;

  ShipmentTemplateTypes = ShipmentCreationTemplateTypes;
  position: ConnectedPosition = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    panelClass: 'full-Width',
  };
  showArrow = false;
  defaultTemplate: ShipmentCreationTemplate;
  defaultTemplates: ShipmentCreationTemplate[];

  RolesConstants = RolesConstants;

  viewCardBtn: boolean = false;

  constructor(
    public layoutService: LayoutService,
    private router: Router,
    private shipmentTemplateService: ShipmentTemplateService,
    private userAPI: UserApi,
    private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.availableTemplates$ = this.userAPI.currentUser$.asObservable().pipe(
      filter((user) => !!user),
      map((user) => dedupeTemplatesByType(user.creationTemplates || [])),
      tap((templates: ShipmentCreationTemplate[]) => {
        templates?.sort((a, b) => Number(b.isDefault) - Number(a.isDefault));
        this.changeDetectorRef.detectChanges();
        this.changeDetectorRef.markForCheck();
        this.showTemplatesMenu = templates?.length > 1;
        return templates;
      })
    );

    this.availableTemplates$.subscribe((data) => {
      this.defaultTemplates = data.filter((temp) => {
        if (temp.isDefault) {
          this.defaultTemplate = temp;
        }
        return !temp.isDefault;
      });
    });

    this.userFirstName = this.userAPI.currentUser$.value?.firstName;
    this.userLastName = this.userAPI.currentUser$.value?.lastName;
    this.userEmail = this.userAPI.currentUser$.value?.email;
    this.userLogo = this.userAPI.currentUser$.value?.whiteLabel?.imageUrl;

    this.viewCardBtn = RolesConstants.SHIPMENT_ADD.includes(this.userAPI.currentUser$.value.roles[0].userRole as any);
  }

  resize$ = fromEvent(window, 'resize')
    .pipe(debounceTime(250), takeUntil(this.destroy$))
    .subscribe(() => {
      if (window.innerWidth < 960) {
        this.navbarCollapse.emit(false);
      } else {
        this.changeOpenMenu.emit(false);
      }
    });

  navigateToTemplate(template: ShipmentCreationTemplateTypes): void {
    this.router.navigateByUrl(this.shipmentTemplateService.getCreateUrl(template));
  }

  closeMenu(): void {
    if (this.openMenu) {
      this.changeOpenMenu.emit(false);
    }
  }

  handlecollapse(event?: Event): void {
    // The expanded button sits inside the brand row's [routerLink]; without this
    // the click collapses the menu and then navigates to the Dashboard.
    event?.stopPropagation();
    this.collapsed = !this.collapsed;
    this.navbarCollapse.emit(this.collapsed);
    this.navList.handleOpenPopover(null);
  }

  onClickCreateShipment(): void {
    if (this.defaultTemplate && this.defaultTemplate.type) {
      this.navigateToTemplate(this.defaultTemplate.type);
    } else if (this.userAPI.currentUser$.value.roles[0].userRole === UserRole.OrganizationOwner) {
      this.matDialog.open(PreCreateShipmentDialogComponent);
    }
  }
}
